import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type HourglassIconProps = Omit<BaseIconProps, 'children'>;

export const HourglassIcon = ({ stroke = '#141B4D', fill = '#141B4D', ...props }: HourglassIconProps) => (
  <BaseIcon
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fill: 'none',
      stroke: 'none',
    }}
    {...props}
  >
    <path
      d="M5 4H19M5 20H19M17 4V8L14 12L17 16V20M7 4V8L10 12L7 16V20"
      stroke={stroke}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M9 17L11.4453 15.3698C11.7812 15.1459 12.2188 15.1459 12.5547 15.3698L15 17V18H9V17Z"
      fill={fill}
    />
    <path
      d="M14.5 7.5L12.8137 9.86077C12.4149 10.4191 11.5851 10.4191 11.1863 9.86077L9.5 7.5H14.5Z"
      fill={fill}
    />
  </BaseIcon>
);

HourglassIcon.displayName = 'HourglassIcon';
